import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import ServiceIcon from "@/components/ServiceIcon";
import { INDUSTRIES } from "@/data/site";

export default function Industries() {
  return (
    <>
      <SEO
        title="Industries"
        description="Security, continuity and compliance consulting for banking and financial services, fintech and payments, technology, telecommunications, public-sector and regulated organizations, professional services and growing enterprises."
        path="/industries"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Industries", path: "/industries" }]}
      />
      <PageHero
        eyebrow="Industries"
        title="Focused on Regulated, High-Stakes Environments"
        description="We concentrate on sectors where security, continuity and compliance are fundamental to operating — and where advice must reflect real regulatory and operational pressure."
        breadcrumb="Industries"
      />

      <section className="bg-white py-16 sm:py-24" data-testid="industries-list">
        <div className="container-site space-y-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.id} delay={0.05}>
              <article
                className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-start rounded-2xl border border-slate-200 bg-white p-7 sm:p-10 hover:border-corp/25 hover:shadow-md transition-[box-shadow,border-color] duration-300"
                data-testid={`industry-section-${ind.id}`}
              >
                <div className="lg:col-span-4 flex lg:flex-col items-start gap-5">
                  <div className="w-14 h-14 rounded-xl bg-navy flex items-center justify-center text-teal shrink-0">
                    <ServiceIcon name={ind.icon} size={26} />
                  </div>
                  <div>
                    <span className="font-mono text-xs text-muted" aria-hidden="true">{String(i + 1).padStart(2, "0")}</span>
                    <h2 className="mt-1 font-heading text-xl sm:text-2xl font-bold tracking-tight text-navy">{ind.name}</h2>
                  </div>
                </div>
                <div className="lg:col-span-8">
                  <p className="text-base leading-relaxed text-muted">{ind.description}</p>
                  <h3 className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-corp">Typical concerns</h3>
                  <ul className="mt-3 flex flex-wrap gap-2">
                    {ind.concerns.map((c) => (
                      <li key={c} className="rounded-full bg-mist border border-slate-200 px-4 py-1.5 text-xs sm:text-sm font-medium text-ink">
                        {c}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection
        title="Operating in a Regulated or High-Stakes Environment?"
        description="Tell us about your sector and obligations. We will outline how our consulting can support your security, continuity and compliance objectives."
      />
    </>
  );
}
